// pages/ImportarReservas.js
import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,Descriptions,
  Select,
  Space,
  Typography,
  message,
  Table,
  Steps,
  Upload,
  Card,
  Row,
  Col,
  Alert,
  Tooltip,
  Divider,
  Tag,
  Input,
  Switch,
  Popconfirm,
  Statistic
} from 'antd';
import {
  HistoryOutlined,StarOutlined, 
  FileExcelOutlined,
  SaveOutlined,
  ReloadOutlined,
  CheckCircleOutlined,
  ExportOutlined ,
  SettingOutlined,
  DatabaseOutlined,
  TableOutlined,
  FileTextOutlined,
  DeleteOutlined,
  ImportOutlined
} from '@ant-design/icons';
import axios from 'axios';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';

import PageContainer from '../components/PageContainer';
import { BASE_URL } from '../utils/constants';

const { Title, Text } = Typography;
const { Option } = Select;
const { Step } = Steps;

const ImportarReservas = () => {
  // Estados para el proceso de importación
  const [currentStep, setCurrentStep] = useState(0);
  const [csvData, setCsvData] = useState([]);
  const [csvHeaders, setCsvHeaders] = useState([]);
  const [csvFileName, setCsvFileName] = useState('');
  const [mappings, setMappings] = useState({});
  const [savedMappings, setSavedMappings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [mappingModalVisible, setMappingModalVisible] = useState(false);
  const [selectedMapping, setSelectedMapping] = useState(null);
  const [mappingName, setMappingName] = useState('');
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const [mappingToDelete, setMappingToDelete] = useState(null);

    const [importing, setImporting] = useState(false);
    const [importResult, setImportResult] = useState(null);
    const [importModalVisible, setImportModalVisible] = useState(false);
    const [historialImportaciones, setHistorialImportaciones] = useState([]);
    const [historialVisible, setHistorialVisible] = useState(false);  

  // Campos destino del sistema
  const targetFields = [
    { key: 'Agencia', label: 'Agencia', required: false, type: 'string' },
    { key: 'Localizador', label: 'Localizador', required: true, type: 'string' },
    { key: 'FechaCreacion', label: 'Fecha Creación', required: true, type: 'date' },
    { key: 'FechaEntrada', label: 'Fecha Entrada', required: true, type: 'date' },
    { key: 'FechaSalida', label: 'Fecha Salida', required: true, type: 'date' },
    { key: 'Adultos', label: 'Adultos', required: true, type: 'number' },
    { key: 'Ninos', label: 'Niños', required: true, type: 'number' },
    { key: 'Bebes', label: 'Bebés', required: false, type: 'number' },
    { key: 'Nombre', label: 'Nombre', required: true, type: 'string' },
    { key: 'NombreCliente', label: 'Nombre Cliente', required: true, type: 'string' },
    { key: 'Regimen', label: 'Régimen', required: true, type: 'string' },
    { key: 'TipoHabitacion', label: 'Tipo de Habitación', required: true, type: 'string' },
    { key: 'Caracteristica', label: 'Característica', required: false, type: 'string' },
    { key: 'Observaciones', label: 'Observaciones', required: false, type: 'string' },
    { key: 'Observaciones2', label: 'Otras Observaciones', required: false, type: 'string' },
    { key: 'Importe', label: 'Importe', required: false, type: 'number' },
    { key: 'Contrato', label: 'Contrato', required: false, type: 'string' }
  ];

  // Columnas para la previsualización
  const previewColumns = targetFields.map(field => ({
    title: field.label,
    dataIndex: field.key,
    key: field.key,
    width: 150,
    render: (text) => {
      if (text === null || text === undefined) return '-';
      return String(text).substring(0, 50);
    }
  }));

  // Cargar mapeos guardados al iniciar
    useEffect(() => {
    fetchSavedMappings();
    fetchHistorialImportaciones();
    
    // Restaurar último mapeo seleccionado
    const ultimoMapeo = localStorage.getItem('ultimoMapeoSeleccionado');
    if (ultimoMapeo) {
        try {
        const mapeoGuardado = JSON.parse(ultimoMapeo);
        // No lo aplicamos automáticamente, solo lo recordamos para cuando se cargue el CSV
        console.log('Último mapeo seleccionado:', mapeoGuardado);
        } catch (error) {
        console.error('Error parseando último mapeo:', error);
        }
    }
    }, []);


    useEffect(() => {
  if (csvHeaders.length > 0) {
    const ultimoMapeo = localStorage.getItem('ultimoMapeoUsado');
    if (ultimoMapeo) {
      try {
        const mapeo = JSON.parse(ultimoMapeo);
        // Verificar que los headers del CSV coincidan aproximadamente
        const headersCoinciden = Object.keys(mapeo.mappings).every(key => 
          !mapeo.mappings[key] || csvHeaders.includes(mapeo.mappings[key])
        );
        
        if (headersCoinciden) {
          Modal.confirm({
            title: '¿Usar último mapeo?',
            icon: <DatabaseOutlined />,
            content: `Se detectó el último mapeo usado: "${mapeo.nombre}". ¿Desea aplicarlo?`,
            okText: 'Sí, aplicar',
            cancelText: 'No',
            onOk: () => {
              setMappings(mapeo.mappings);
              setSelectedMapping({ id: mapeo.id, nombre: mapeo.nombre });
              message.success(`Mapeo "${mapeo.nombre}" aplicado automáticamente`);
            }
          });
        }
      } catch (error) {
        console.error('Error aplicando último mapeo:', error);
      }
    }
  }
}, [csvHeaders]);


  const fetchSavedMappings = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/api/importaciones/mapeos`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSavedMappings(response.data.data || []);
    } catch (error) {
      console.error('Error cargando mapeos:', error);
      message.error('Error al cargar los mapeos guardados');
    }
  };

const fetchHistorialImportaciones = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${BASE_URL}/api/importaciones/importaciones/historial`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setHistorialImportaciones(response.data.data || []);
  } catch (error) {
    console.error('Error cargando historial:', error);
  }
};  

const handleSaveAsFavorite = () => {
  if (!selectedMapping) {
    message.warning('No hay ningún mapeo seleccionado');
    return;
  }
  
  localStorage.setItem('mapeoFavorito', JSON.stringify({
    id: selectedMapping.id,
    nombre: selectedMapping.nombre,
    mappings: mappings,
    fecha: new Date().toISOString()
  }));
  
  message.success(`Mapeo "${selectedMapping.nombre}" guardado como favorito`);
};

// Añadir esta función en la sección de funciones, antes del return
const handleExport = () => {
  const processedData = processMappedData();
  if (!processedData) return;

  // Crear CSV para exportar
  const csvContent = Papa.unparse(processedData, {
    delimiter: ';',
    quotes: true,
    quoteChar: '"',
    escapeChar: '"',
    columns: targetFields.map(f => f.key)
  });

  // Añadir BOM para UTF-8
  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `reservas_export_${new Date().toISOString().slice(0,10)}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);

  message.success(`CSV exportado con ${processedData.length} reservas`);
};

const handleImportReservas = async () => {
  const processedData = processMappedData();
  if (!processedData) return;

  // Confirmar antes de importar
  Modal.confirm({
    title: 'Confirmar importación',
    icon: <ImportOutlined />,
    content: (
      <div>
        <p>¿Está seguro de que desea importar estas reservas?</p>
        <p><strong>Total reservas:</strong> {processedData.length}</p>
        <p><strong>Archivo:</strong> {csvFileName}</p>
        <p style={{ color: '#ff4d4f' }}>
          Esta acción insertará o modificará reservas en la base de datos.
        </p>
      </div>
    ),
    okText: 'Importar',
    cancelText: 'Cancelar',
    okButtonProps: { danger: true },
    onOk: async () => {
      setImporting(true);
      try {
        const token = localStorage.getItem('token');
        const hotelId = localStorage.getItem('hotelId') || 1; // Ajustar según tu sistema
        const usuario = localStorage.getItem('username') || 'Sistema';

        console.log(" mapping => ",selectedMapping,mappings);
        
        const mappingToSave = {
            nombre: selectedMapping.nombre,
            mappings: mappings,
            headers: csvHeaders
        };        
        console.log(" mappingToSave => ",mappingToSave);
        
        
        await axios.post(`${BASE_URL}/api/importaciones/mapeos`, mappingToSave, {
            headers: { Authorization: `Bearer ${token}` }
        });

        const response = await axios.post(
          `${BASE_URL}/api/importaciones/reservas/importar`,
          {
            reservas: processedData,
            mapeoId: selectedMapping?.id,
            hotelId,
            usuario
          },
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        setImportResult(response.data.data);
        setImportModalVisible(true);
        
        // Actualizar historial
        fetchHistorialImportaciones();
        
        message.success(`Importación completada: ${response.data.data.insertadas} insertadas, ${response.data.data.modificadas} modificadas`);
        
      } catch (error) {
        console.error('Error en importación:', error);
        message.error(error.response?.data?.error || 'Error en la importación');
      } finally {
        setImporting(false);
      }
    }
  });
};

  // Manejar carga del CSV
//   const handleFileUpload = (file) => {
//     setLoading(true);
//     setCsvFileName(file.name);
    
//     Papa.parse(file, {
//       header: true,
//       skipEmptyLines: true,
//       encoding: 'UTF-8',
//       complete: (results) => {
//         if (results.data && results.data.length > 0) {

//             console.log(" results.data => ",results.data);
            
//           const headers = Object.keys(results.data[0]);
//           setCsvHeaders(headers);
//           setCsvData(results.data);
//           setPreviewData(results.data.slice(0, 10));
          
//           // Intentar cargar mapeo automático
//           const autoMappings = detectMappings(headers);
//           setMappings(autoMappings);
          
//           message.success(`CSV cargado correctamente: ${results.data.length} filas`);
//           setCurrentStep(1);
//         } else {
//           message.warning('El archivo CSV está vacío');
//         }
//         setLoading(false);
//       },
//       error: (error) => {
//         message.error('Error al parsear el CSV: ' + error.message);
//         setLoading(false);
//       }
//     });
    
//     return false;
//   };

    const handleFileUpload = (file) => {
        setLoading(true);
        setCsvFileName(file.name);
  
        const fileExtension = file.name.split('.').pop().toLowerCase();
  
        if (fileExtension === 'csv') {
            // Procesar CSV con PapaParse (código existente)
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                encoding: 'UTF-8',
                complete: (results) => {
                    procesarDatosParseados(results.data);
                },
                error: (error) => {
                    message.error('Error al parsear el CSV: ' + error.message);
                    setLoading(false);
                }
            });
        } else if (['xlsx', 'xls'].includes(fileExtension)) {
            // Procesar Excel con SheetJS
            const reader = new FileReader();
    
            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
        
                    // Tomar la primera hoja
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
        
                    // Convertir a JSON (con encabezados)
                    const jsonData = XLSX.utils.sheet_to_json(worksheet, { 
                        header: 1,
                        defval: '' // Valor por defecto para celdas vacías
                    });
        
                    // La primera fila son los encabezados
                    const headers = jsonData[0] || [];
                    // El resto son los datos
                    const rows = jsonData.slice(1).map(row => {
                        const rowObj = {};
                        headers.forEach((header, index) => {
                            rowObj[header] = row[index] !== undefined ? String(row[index]).trim() : '';
                        });
                        return rowObj;
                    });
        
                    procesarDatosParseados(rows, headers);
        
                } catch (error) {
                    message.error('Error al parsear el Excel: ' + error.message);
                    setLoading(false);
                }
            };
    
            reader.readAsArrayBuffer(file);
        } else {
            message.error('Formato no soportado. Use .csv, .xls o .xlsx');
            setLoading(false);
        }
    };

    const procesarDatosParseados = (rows, headers) => {
        if (rows && rows.length > 0) {
            // Si no tenemos headers explícitos, obtenerlos de la primera fila
            const finalHeaders = headers || Object.keys(rows[0]);
    
            setCsvHeaders(finalHeaders);
            setCsvData(rows);
            setPreviewData(rows.slice(0, 10));
    
            // Detectar mapeos automáticos
            const autoMappings = detectMappings(finalHeaders);
            setMappings(autoMappings);
    
            message.success(`Archivo cargado correctamente: ${rows.length} filas`);
            setCurrentStep(1);
        } else {
            message.warning('El archivo está vacío');
        }
        setLoading(false);
    };    

  // Detectar mapeos automáticos basados en nombres de columnas
  const detectMappings = (headers) => {
    const mappings = {};
    const lowerHeaders = headers.map(h => h.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
    
    targetFields.forEach(field => {
      const fieldLower = field.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const fieldKey = field.key.toLowerCase();
      
      // Buscar coincidencia exacta o parcial
      const index = headers.findIndex((header, i) => {
        const headerLower = lowerHeaders[i];
        return headerLower === fieldLower || 
               headerLower === fieldKey ||
               headerLower.includes(fieldLower) ||
               fieldLower.includes(headerLower);
      });
      
      if (index !== -1) {
        mappings[field.key] = headers[index];
      }
    });
    
    return mappings;
  };

  // Cargar un mapeo guardado
const handleLoadMapping = (mapping) => {
  if (!csvHeaders || csvHeaders.length === 0) {
    message.warning('Primero debe cargar un archivo CSV');
    return;
  }
  
  setSelectedMapping(mapping);
  setMappings(mapping.mappings);
  
  // Guardar el mapeo en localStorage para persistencia
  localStorage.setItem('ultimoMapeoSeleccionado', JSON.stringify({
    id: mapping.id,
    nombre: mapping.nombre,
    timestamp: new Date().toISOString()
  }));
  
  message.success(`Mapeo "${mapping.nombre}" cargado`);
};

  // Guardar mapeo
  const handleSaveMapping = async () => {
    if (!mappingName.trim()) {
      message.warning('Por favor ingrese un nombre para el mapeo');
      return;
    }

    if (!csvHeaders || csvHeaders.length === 0) {
      message.warning('No hay headers de CSV para guardar');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const mappingToSave = {
        nombre: mappingName,
        mappings: mappings,
        headers: csvHeaders
      };

      await axios.post(`${BASE_URL}/api/importaciones/mapeos`, mappingToSave, {
        headers: { Authorization: `Bearer ${token}` }
      });

      message.success('Mapeo guardado correctamente');
      setMappingModalVisible(false);
      setMappingName('');
      fetchSavedMappings();
    } catch (error) {
      message.error('Error al guardar el mapeo');
    }
  };

  // Eliminar mapeo
  const handleDeleteMapping = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${BASE_URL}/api/importaciones/mapeos/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      message.success('Mapeo eliminado correctamente');
      fetchSavedMappings();
      setDeleteConfirmVisible(false);
      setMappingToDelete(null);
    } catch (error) {
      message.error('Error al eliminar el mapeo');
    }
  };

  // Procesar datos con mapeo
//   const processMappedData = () => {
//     // Validar campos requeridos
//     const missingFields = targetFields
//       .filter(field => field.required && !mappings[field.key])
//       .map(field => field.label);

//     if (missingFields.length > 0) {
//       message.warning(`Campos requeridos sin mapear: ${missingFields.join(', ')}`);
//       return null;
//     }
//     // console.log(" csvData => ",csvData);
    
//     const processed = csvData.map((row, index) => {
//       const mappedRow = {};
      
//       targetFields.forEach(field => {
//         const sourceColumn = mappings[field.key];
//         if (sourceColumn && row[sourceColumn] !== undefined) {
//           let value = row[sourceColumn]?.toString().trim() || '';
          
//           // Conversión de tipos
//           if (field.type === 'number') {
//             // Limpiar formato de número (eliminar puntos de miles, convertir coma a punto)
//             value = value.replace(/\./g, '').replace(',', '.');
//             value = parseFloat(value) || 0;
//           } else if (field.type === 'date') {
//             // Convertir formato YYYYMMDD a YYYY-MM-DD
//             if (/^\d{8}$/.test(value)) {
//               value = `${value.substring(0,4)}-${value.substring(4,6)}-${value.substring(6,8)}`;
//             }
//           }
          
//           mappedRow[field.key] = value;
//         } else {
//           mappedRow[field.key] = field.type === 'number' ? 0 : '';
//         }
//       });
      
//       return mappedRow;
//     });

//     return processed;
//   };


// Función para formatear código de agencia
function formatearCodigoAgencia(codigo) {
  if (!codigo) return '';
  
  // Convertir a string si es número
  const codigoStr = String(codigo).trim();
  
  // Si es exactamente "03", mantenerlo así
  if (codigoStr === '03' || codigoStr === '3') {
    return '03';
  }
  
  // Para otros casos, eliminar ceros a la izquierda
  // Convertir a número y luego a string para eliminar ceros
  const numero = parseInt(codigoStr, 10);
  
  // Si la conversión falla o es NaN, devolver el original
  if (isNaN(numero)) {
    return codigoStr;
  }
  
  return String(numero);
}



const handleContinue = () => {
  const processed = processMappedData();
  if (processed) {
    // Si hay un mapeo seleccionado, guardarlo como el último usado
    if (selectedMapping) {
      localStorage.setItem('ultimoMapeoUsado', JSON.stringify({
        id: selectedMapping.id,
        nombre: selectedMapping.nombre,
        mappings: selectedMapping.mappings,
        fecha: new Date().toISOString()
      }));
    }
    setCurrentStep(2);
  }
};


    const processMappedData = () => {
    // Validar campos requeridos
    const missingFields = targetFields
        .filter(field => field.required && !mappings[field.key])
        .map(field => field.label);

    if (missingFields.length > 0) {
        message.warning(`Campos requeridos sin mapear: ${missingFields.join(', ')}`);
        return null;
    }

    // Primero, procesar todas las líneas individualmente
    const lineasProcesadas = csvData.map((row, index) => {
        const mappedRow = {};
        
        targetFields.forEach(field => {
        const sourceColumn = mappings[field.key];
        if (sourceColumn && row[sourceColumn] !== undefined) {
            let value = row[sourceColumn]?.toString().trim() || '';
            
            // Aplicar formateo especial para Agencia
            if (field.key === 'Agencia') {
            value = formatearCodigoAgencia(value);
            } else if (field.type === 'number') {
            // Limpiar formato de número (eliminar puntos de miles, convertir coma a punto)
            value = value.replace(/\./g, '').replace(',', '.');
            value = parseFloat(value) || 0;
            } else if (field.type === 'date') {
            // Convertir formato YYYYMMDD a YYYY-MM-DD
            if (/^\d{8}$/.test(value)) {
                value = `${value.substring(0,4)}-${value.substring(4,6)}-${value.substring(6,8)}`;
            }
            }
            
            mappedRow[field.key] = value;
        } else {
            mappedRow[field.key] = field.type === 'number' ? 0 : '';
        }
        });
        
        // Añadir el índice de línea original por si acaso
        mappedRow._lineaOriginal = index;
        mappedRow._numReserva = row[mappings['NumReserva']] || row.NşRESERVA || row.NRESERVA || '';
        
        return mappedRow;
    });

    // Ahora, agrupar por identificador de reserva
    // Usamos una combinación de localizador + agencia + fechas como clave única
    const reservasMap = new Map();
    
    lineasProcesadas.forEach(linea => {
        // Crear una clave única para la reserva
        // Si hay número de reserva en el CSV, usarlo
        const claveReserva = linea._numReserva || 
                            `${linea.Localizador}_${linea.Agencia}_${linea.FechaEntrada}_${linea.FechaSalida}`;
        
        if (!reservasMap.has(claveReserva)) {
        // Primera línea de esta reserva
        reservasMap.set(claveReserva, {
            // Datos comunes de la reserva
            Agencia: linea.Agencia,
            Localizador: linea.Localizador,
            FechaCreacion: linea.FechaCreacion,
            FechaEntrada: linea.FechaEntrada,
            FechaSalida: linea.FechaSalida,
            Nombre: linea.Nombre,
            Regimen: linea.Regimen,
            Contrato: linea.Contrato,
            // Arrays para las habitaciones
            habitaciones: [{
            Habitacion: linea.Habitacion || 1,
            Adultos: linea.Adultos,
            Ninos: linea.Ninos,
            Bebes: linea.Bebes,
            TipoHabitacion: linea.TipoHabitacion,
            Caracteristica: linea.Caracteristica,
            NombreCliente: linea.NombreCliente,
            Importe: linea.Importe,
            _lineaOriginal: linea._lineaOriginal
            }]
        });
        } else {
        // Añadir habitación a reserva existente
        const reserva = reservasMap.get(claveReserva);
        reserva.habitaciones.push({
            Habitacion: linea.Habitacion || reserva.habitaciones.length + 1,
            Adultos: linea.Adultos,
            Ninos: linea.Ninos,
            Bebes: linea.Bebes,
            TipoHabitacion: linea.TipoHabitacion,
            Caracteristica: linea.Caracteristica,
            NombreCliente: linea.NombreCliente,
            Importe: linea.Importe,
            _lineaOriginal: linea._lineaOriginal
        });
        }
    });

    // Convertir el mapa a array y calcular totales
    const reservasAgrupadas = Array.from(reservasMap.values()).map(reserva => {
        // Calcular totales de la reserva
        const totalAdultos = reserva.habitaciones.reduce((sum, h) => sum + (h.Adultos || 0), 0);
        const totalNinos = reserva.habitaciones.reduce((sum, h) => sum + (h.Ninos || 0), 0);
        const totalBebes = reserva.habitaciones.reduce((sum, h) => sum + (h.Bebes || 0), 0);
        const importeTotal = reserva.habitaciones.reduce((sum, h) => sum + (h.Importe || 0), 0);
        
        return {
        ...reserva,
        totalAdultos,
        totalNinos,
        totalBebes,
        importeTotal,
        numHabitaciones: reserva.habitaciones.length
        };
    });

    console.log(`📊 Procesadas ${lineasProcesadas.length} líneas agrupadas en ${reservasAgrupadas.length} reservas`);
    
    return reservasAgrupadas;
    };

  // Generar JSON final
  const handleGenerateJSON = () => {
    const processedData = processMappedData();
    if (!processedData) return;

    const jsonOutput = {
      metadata: {
        fecha_importacion: new Date().toISOString(),
        archivo_original: csvFileName,
        total_registros: processedData.length,
        mappings: mappings,
        headers_originales: csvHeaders
      },
      reservas: processedData
    };

    // Crear y descargar archivo
    const blob = new Blob([JSON.stringify(jsonOutput, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `reservas_${new Date().toISOString().slice(0,10)}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    message.success(`JSON generado con ${processedData.length} reservas`);
    setCurrentStep(2);
  };

  // Volver al paso anterior
  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  // Resetear importación
  const handleReset = () => {
    setCurrentStep(0);
    setCsvData([]);
    setCsvHeaders([]);
    setCsvFileName('');
    setMappings({});
    setPreviewData([]);
  };

  // Renderizar paso 1: Carga de CSV
  const renderStep1 = () => (
    <Card>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Alert
          message="Formato esperado"
          description="El archivo CSV debe contener las reservas del hotel. Se detectarán automáticamente las columnas para el mapeo."
          type="info"
          showIcon
        />
        
        <Upload.Dragger
          name="file"
        //   accept=".csv,.txt"
            accept=".csv,.xlsx,.xls"
          beforeUpload={handleFileUpload}
          showUploadList={false}
          disabled={loading}
        >
            <p className="ant-upload-drag-icon">
                <FileExcelOutlined style={{ fontSize: 48, color: '#52c41a' }} />
            </p>
            <p className="ant-upload-text">Haga clic o arrastre el archivo CSV o Excel aquí</p>
            <p className="ant-upload-hint">
                Soporta archivos .csv, .xlsx y .xls. Máximo 100MB.
            </p>
        </Upload.Dragger>
      </Space>
    </Card>
  );

    // Función para convertir fecha de Excel a formato YYYY-MM-DD
    function convertirFechaExcel(valor) {
        if (typeof valor === 'number') {
            // Excel fecha serial: días desde 1900-01-01
            const fecha = new Date((valor - 25569) * 86400 * 1000);
            const year = fecha.getFullYear();
            const month = String(fecha.getMonth() + 1).padStart(2, '0');
            const day = String(fecha.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
        return valor;
    }

    // Usar en el mapeo
    // if (field.type === 'date' && typeof value === 'number') {
    //     value = convertirFechaExcel(value);
    // }

  // Renderizar paso 2: Mapeo de campos
  const renderStep2 = () => (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Card>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Space wrap>
              <Button
                type="primary"
                icon={<SaveOutlined />}
                onClick={() => setMappingModalVisible(true)}
              >
                Guardar Mapeo Actual
              </Button>
              <Button
                icon={<ReloadOutlined />}
                onClick={() => setMappings(detectMappings(csvHeaders))}
              >
                Detectar Automático
              </Button>
              {/* <Button onClick={handleBack}> Volver </Button> */}

      <Row justify="end">
        <Space>
          <Button onClick={handleReset}>Cancelar</Button>
          <Button 
            type="primary" 
            // onClick={() => {
            //   const processed = processMappedData();
            //   if (processed) setCurrentStep(2);
            // }}
                onClick={handleContinue}            
          >
            Continuar
          </Button>
<Button
  icon={<StarOutlined />}
  onClick={handleSaveAsFavorite}
  disabled={!selectedMapping}
>
  Guardar como favorito
</Button>          
        </Space>
      </Row>

            </Space>
          </Col>
        </Row>
        
        <Divider />
        
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Card size="small" title="Archivo" extra={<Tag color="blue">{csvFileName}</Tag>}>
              <Statistic 
                title="Registros" 
                value={csvData.length} 
                suffix={`columnas: ${csvHeaders.length}`}
              />
            </Card>
          </Col>
          <Col span={16}>
            <Card size="small" title="Mapeos guardados">
              <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                {savedMappings.length > 0 ? (
                  savedMappings.map((mapping) => (
                    <div key={mapping.id} style={{ marginBottom: 8, display: 'flex', alignItems: 'center' }}>
                      <Button
                        type={selectedMapping?.id === mapping.id ? 'primary' : 'default'}
                        icon={<DatabaseOutlined />}
                        onClick={() => handleLoadMapping(mapping)}
                        style={{ flex: 1, marginRight: 8 }}
                      >
                        {mapping.nombre}
                      </Button>
                      <Popconfirm
                        title="¿Eliminar mapeo?"
                        description="Esta acción no se puede deshacer"
                        onConfirm={() => handleDeleteMapping(mapping.id)}
                        okText="Sí"
                        cancelText="No"
                        okButtonProps={{ danger: true }}
                      >
                        <Button 
                          danger 
                          icon={<DeleteOutlined />} 
                          size="small"
                        />
                      </Popconfirm>
                    </div>
                  ))
                ) : (
                  <Text type="secondary">No hay mapeos guardados</Text>
                )}
              </div>
            </Card>
          </Col>
        </Row>
        
        <Divider />
        
        <Table
          dataSource={targetFields}
          rowKey="key"
          pagination={false}
          size="middle"
          columns={[
            {
              title: 'Campo Destino',
              dataIndex: 'label',
              key: 'label',
              width: '30%',
              render: (text, record) => (
                <Space>
                  <Text strong>{text}</Text>
                  {record.required && <Tag color="red">Requerido</Tag>}
                </Space>
              )
            },
            {
              title: 'Columna CSV',
              dataIndex: 'key',
              key: 'mapping',
              width: '70%',
              render: (_, record) => (
                <Select
                  style={{ width: '100%' }}
                  placeholder="Seleccionar columna"
                  value={mappings[record.key]}
                  onChange={(value) => setMappings(prev => ({
                    ...prev,
                    [record.key]: value
                  }))}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                >
                  {csvHeaders.map(header => (
                    <Option key={header} value={header}>
                      {header}
                    </Option>
                  ))}
                </Select>
              )
            }
          ]}
        />
      </Card>

      <Card title="Previsualización CSV (primeras 10 filas)">
        <Table
          dataSource={previewData.map((row, index) => ({
            ...row,
            key: index
          }))}
          columns={csvHeaders.slice(0, 8).map(header => ({
            title: header,
            dataIndex: header,
            key: header,
            width: 150,
            ellipsis: true,
            render: (text) => {
              if (text === null || text === undefined) return '-';
              return String(text).substring(0, 30);
            }
          }))}
          scroll={{ x: 1000 }}
          size="small"
          pagination={false}
        />
      </Card>


    </Space>
  );

  // Renderizar paso 3: Vista previa del JSON
  const renderStep3 = () => {
    const processedData = processMappedData();
    if (!processedData) return null;

    return (
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Card>
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <Statistic
                title="Total Reservas"
                value={processedData.length}
                prefix={<TableOutlined />}
              />
            </Col>
            <Col span={6}>
              <Statistic
                title="Campos Mapeados"
                value={Object.keys(mappings).length}
                prefix={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
              />
            </Col>
            <Col span={6}>
              <Statistic
                title="Campos Requeridos"
                value={targetFields.filter(f => f.required).length}
                prefix={<DatabaseOutlined />}
              />
            </Col>
            <Col span={6}>
              <Button
                type="primary"
                icon={<FileTextOutlined />}
                size="large"
                onClick={handleGenerateJSON}
                block
              >
                Descargar JSON
              </Button>
            </Col>
            <Col span={6}>
            <Button
                type="primary"
                danger
                icon={<ImportOutlined />}
                size="large"
                onClick={handleImportReservas}
                loading={importing}
                block
            >
                Importar a BD
            </Button>
            </Col>            
          </Row>
        </Card>

        <Card title="Vista previa de datos mapeados (primeras 20 filas)">
          <Table
            dataSource={processedData.slice(0, 20).map((row, index) => ({
              ...row,
              key: index
            }))}
            columns={previewColumns}
            scroll={{ x: 2000, y: 400 }}
            size="small"
            pagination={false}
          />
        </Card>

        <Row justify="end">
          <Space>
            <Button onClick={handleBack}>Volver al mapeo</Button>
            <Button onClick={handleReset}>Nueva importación</Button>
          </Space>
        </Row>
      </Space>
    );
  };

  return (
    <PageContainer
      title="Importar Reservas"
      subtitle="Importa reservas desde archivo CSV"
      icon={<DatabaseOutlined />}
      loading={loading}
        extra={
        <Space>
            <Button
            icon={<HistoryOutlined />}
            onClick={() => setHistorialVisible(true)}
            >
            Historial
            </Button>
            <Button
            icon={<ExportOutlined />}
            onClick={handleExport}
            >
            Exportar
            </Button>
        </Space>
        }      
    >
      <Steps current={currentStep} style={{ marginBottom: 24 }}>
        <Step title="Cargar CSV" icon={<FileExcelOutlined />} />
        <Step title="Mapear Campos" icon={<SettingOutlined />} />
        <Step title="Generar JSON" icon={<FileTextOutlined />} />
      </Steps>

      {currentStep === 0 && renderStep1()}
      {currentStep === 1 && renderStep2()}
      {currentStep === 2 && renderStep3()}

      {/* Modal para guardar mapeo */}
      <Modal
        title="Guardar Mapeo"
        open={mappingModalVisible}
        onOk={handleSaveMapping}
        onCancel={() => {
          setMappingModalVisible(false);
          setMappingName('');
        }}
      >
        <Form layout="vertical">
          <Form.Item
            label="Nombre del mapeo"
            required
            tooltip="Nombre descriptivo para identificar este mapeo"
          >
            <Input
              placeholder="Ej: Mapeo estándar reservas"
              value={mappingName}
              onChange={(e) => setMappingName(e.target.value)}
            />
          </Form.Item>
          <Alert
            message="El mapeo guardado incluirá la relación entre las columnas del CSV y los campos del sistema"
            type="info"
            showIcon
          />
        </Form>
      </Modal>

        <Modal
        title="Resultado de Importación"
        open={importModalVisible}
        onCancel={() => setImportModalVisible(false)}
        footer={[
            <Button key="close" onClick={() => setImportModalVisible(false)}>
            Cerrar
            </Button>
        ]}
        width={600}
        >
        {importResult && (
            <div>
            <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="Total reservas">
                <Tag color="blue">{importResult.total}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Insertadas">
                <Tag color="green">{importResult.insertadas}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Modificadas">
                <Tag color="orange">{importResult.modificadas}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Omitidas">
                <Tag color="gray">{importResult.omitidas}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Errores">
                <Tag color="red">{importResult.errores}</Tag>
                </Descriptions.Item>
            </Descriptions>

            {importResult.detalles && importResult.detalles.length > 0 && (
                <>
                <Divider />
                <Text strong>Detalle:</Text>
                <div style={{ maxHeight: 200, overflowY: 'auto', marginTop: 8 }}>
                    {importResult.detalles.map((detalle, idx) => (
                    <div key={idx} style={{ 
                        padding: '4px 8px', 
                        margin: '2px 0',
                        backgroundColor: detalle.estado === 'error' ? '#fff1f0' : '#f6ffed',
                        borderRadius: 4
                    }}>
                        <Space>
                        <Text code>{detalle.localizador}</Text>
                        {detalle.numReserva && <Tag color="blue">#{detalle.numReserva}</Tag>}
                        <Tag color={
                            detalle.estado === 'insertada' ? 'green' :
                            detalle.estado === 'modificada' ? 'orange' :
                            detalle.estado === 'omitida' ? 'gray' : 'red'
                        }>
                            {detalle.estado}
                        </Tag>
                        {detalle.error && <Text type="danger">{detalle.error}</Text>}
                        </Space>
                    </div>
                    ))}
                </div>
                </>
            )}
            </div>
        )}
        </Modal>      

    
    <Modal
    title="Historial de Importaciones"
    open={historialVisible}
    onCancel={() => setHistorialVisible(false)}
    footer={[
        <Button key="close" onClick={() => setHistorialVisible(false)}>
        Cerrar
        </Button>
    ]}
    width={800}
    >
    <Table
        dataSource={historialImportaciones}
        rowKey="Id"
        size="small"
        pagination={{ pageSize: 5 }}
        columns={[
        {
            title: 'Fecha',
            dataIndex: 'Fecha',
            key: 'Fecha',
            render: (fecha) => new Date(fecha).toLocaleString('es-ES')
        },
        {
            title: 'Tipo',
            dataIndex: 'Tipo',
            key: 'Tipo',
            render: (tipo) => <Tag color="blue">{tipo}</Tag>
        },
        {
            title: 'Registros',
            dataIndex: 'TotalRegistros',
            key: 'TotalRegistros',
            render: (total) => <Tag color="purple">{total}</Tag>
        },
        {
            title: 'Resultado',
            key: 'resultado',
            render: (_, record) => {
            try {
                const obs = JSON.parse(record.Observaciones || '{}');
                return (
                <Space>
                    <Tooltip title="Insertadas">
                    <Tag color="green">{obs.insertadas || 0}</Tag>
                    </Tooltip>
                    <Tooltip title="Modificadas">
                    <Tag color="orange">{obs.modificadas || 0}</Tag>
                    </Tooltip>
                    <Tooltip title="Errores">
                    <Tag color="red">{obs.errores || 0}</Tag>
                    </Tooltip>
                </Space>
                );
            } catch {
                return '-';
            }
            }
        },
        {
            title: 'Usuario',
            dataIndex: 'Usuario',
            key: 'Usuario',
            render: (usuario) => (
            <Space>
                <UserOutlined />
                {usuario}
            </Space>
            )
        },
        {
            title: 'Estado',
            dataIndex: 'Estado',
            key: 'Estado',
            render: (estado) => (
            <Tag color={estado === 'COMPLETADO' ? 'green' : 'red'}>
                {estado}
            </Tag>
            )
        }
        ]}
    />
    </Modal>        
    </PageContainer>
  );
};

export default ImportarReservas;